import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const CheckmarkIcon: FC<SvgProps> = (props) => {
    return (
        <Svg viewBox="0 0 24 24" height={24} width={24} {...props}>
            <Path d="M9.55 17.725a1.2 1.2 0 0 1-.425-.075 1.056 1.056 0 0 1-.375-.25l-4.3-4.3a1.06 1.06 0 0 1-.312-.813c.008-.325.12-.595.337-.812.217-.217.488-.325.813-.325.325 0 .587.108.787.325L9.55 14.95l8.375-8.375c.2-.217.467-.325.8-.325s.608.108.825.325c.2.217.3.487.3.812 0 .325-.1.596-.3.813l-9.2 9.2c-.117.117-.242.2-.375.25a1.2 1.2 0 0 1-.425.075Z" />
        </Svg>
    )
}

export default CheckmarkIcon
